<template>
  <div style="background-color:white">
    <el-row style="padding-top:10px">
      <el-col :span="24">
        <el-button size="small" class="btn" type="primary" v-if="show.sh" @click="handleCreate">维保审核</el-button>
        <!-- <el-button size="small" type="primary" disabled="true" class="btn">导出列表</el-button> -->

        <el-form :inline="true" ref="deviceInfo" :model="deviceInfo" class="demo-form-inline"
          style="float:right!important">
          <el-form-item label="日期">
            <el-date-picker v-model="deviceInfo.date" type="daterange" value-format="yyyy-MM-dd" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input v-model="deviceInfo.content" auto-complete="off" placeholder="请输入搜索内容"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }" ref="multipleTable" :row-key="getRowKeys" :data="maintenanceData"
          tooltip-effect="dark" style="width: 100%;text-align: center" stripe>
          <el-table-column type="selection" :reserve-selection="true" width="55"> </el-table-column>
          <el-table-column :label="lable.index" type="index" show-overflow-tooltip >
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link :underline="false" @click="onClick(scope.row)" style="color: #4095E5;text-decoration: none;">
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column prop="glbh" :label="lable.glbh" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="zcmc" :label="lable.zcmc" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ssdw" :label="lable.ssdw" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="applyTime" :label="lable.applyTime" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="userName" :label="lable.userName" show-overflow-tooltip>
          </el-table-column>
          <!-- <el-table-column prop="preson" label="申请人" show-overflow-tooltip>
          </el-table-column> -->
          <el-table-column prop="reason" :label="lable.reason" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="statue" :label="lable.statue" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '1'" style="color:#4095E5">待审核</span>
              <span v-else-if="scope.row.statue == '1.5'" style="color:#4095E5">待审核</span>

            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top:5px;height: 35px;">
        <el-pagination v-if="maintenanceData.length > 0" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:right">
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------维保审核弹框--------------------------------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="维保审核"
      style="width:90% !important;margin-left: 200px;">
      <el-form :model="questionForm" ref="dataForm" label-position="left" size="mini" label-width="100px"
        style="width: 90%; margin-left:5%;">

        <el-row>
          <el-col :span="12">
            <el-form-item style="width:90%" :label="lable.id">
              <el-input :readonly="true" v-model="questionForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.glbh">
              <el-input :readonly="true" v-model="questionForm.glbh" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.ssdw" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.ssdw" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.userName">
              <el-input :readonly="true" v-model="questionForm.userName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.applyTime" style="width:90%">
              <el-input :readonly="true" v-model="questionForm.applyTime" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.companyName">
              <el-input :readonly="true" v-model="questionForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="维保类型">
          <el-input :readonly="true" v-if="questionForm.maintenanceType == '0'" value="设备维修" />
          <el-input :readonly="true" v-else-if="questionForm.maintenanceType == '1'" value="设备保养" />
        </el-form-item>
        <el-form-item :label="lable.reason">
          <el-input :readonly="true" v-model="questionForm.reason" />
        </el-form-item>
        <el-form-item label="业务流程">
          <el-table :data="ywTable" :border="true" style="width: 100%;text-align: center" size="mini"
            max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="createTime" label="时间" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="nodeName" label="事件" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="workflowResult" label="审批结果" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="bz" label="审核意见" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="userId" label="操作人" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item :label="lable.wbr" prop="list">
          <el-select v-model="questionForm.list" @change="selectChangeHandle" multiple style="width: 100%"
            placeholder="请选择">
            <el-option v-for="item in options" :key="item.userId" :label="item.userName" :value="item.userId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="lable.processReson">
          <el-input type="processReson" :rows="2" placeholder="请输入内容" v-model="questionForm.workflowContent">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="auidt" v-preventReClick>通过</el-button>
        <el-button style="margin-left: 10px;" type="danger" @click="noAuidt" v-preventReClick>驳回</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!------------------------------------------------------------------------维保批量审核弹框------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" title="维保批量审核"
      style="width:90% !important;margin-left: 10%;">
      <el-form :model="questionForm1" ref="dataForm" label-position="left" label-width="100px"
        style="width: 50%; margin-left:20%;">
        <el-form-item :label="lable.wbr">
          <el-row><el-col :span="20">
              <el-select style="width:100%" v-model="questionForm1.list" @change="selectChangeHandle" multiple
                placeholder="请选择">
                <el-option v-for="item in options" :key="item.userId" :label="item.userName" :value="item.userId">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :push="1">
              <el-button type="primary" disabled>多选</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item :label="lable.processReson">
          <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="questionForm1.workflowContent">
          </el-input>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" :border="true" style="width: 90%;margin-left: 20PX;text-align: center" size="mini"
        max-height="235px" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
        :cell-style="{ textAlign: 'center' }">
        <el-table-column label="序号" type="index" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="deviceId" label="资产编号" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="id" label="资产编号" v-if="false">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="200px">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px;" type="primary" @click="batchAuidt" v-preventReClick>通过</el-button>
        <el-button style="margin-left: 10px;" type="danger" @click="batchNoAuidt" v-preventReClick>驳回</el-button>
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  findByModule,
  auditMaintenance,
  approveByIdMaintenance,
  findByRoleUser,
  findByIdWorkflow,
} from "../../api/api";

export default {
  name: "Audit",
  data() {
    return {
      deviceInfo: {
        date: [],
        content: "",
        state: ""
      },
      show: {
        sh: false
      },
      ywTable: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      lable: {},
      maintenanceData: [],
      questionForm: {
        id: "",
        workflowContent: ""
      },
      options: [],
      tableData: [],
      multipleTable: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      questionForm1: {
        workflowContent: ""
      },
      wxry: {
        jcwb: [],
        bgwb: []
      }
    };
  },
  methods: {
    selectChangeHandle() {
      this.$forceUpdate()
    },
    getRowKeys(row) {
      return row.id;
    },
    handleClick(row) {
      let obj = this.tableData.findIndex(item => {
        if (item.id == row.id) {
          return true;
        }
      });
      this.tableData.splice(obj, 1);
    },
    onClick(row) {
      if (this.show.sh) {
        this.questionForm = row;
        if (this.questionForm.yjfl == 'P0001') {
          this.options = this.wxry.bgwb
        }
        if (this.questionForm.yjfl == "P0002") {
          this.options = this.wxry.jcwb
        }
        var a = []
        if (this.questionForm.person != null) {
          a = this.questionForm.person.split(",")
        }
        this.findByIdWork(this.questionForm.id)
        this.questionForm.list = a
        this.dialogFormVisible = true;
      } else {
        this.$message.warning("您不具有该权限！")
      }

    },
    //审核通过
    auidt() {
      let map = {
        id: this.questionForm.id,
        list: this.questionForm.list,
        workflowContent: this.questionForm.workflowContent,
        sout: 0
      };
      this.audit(map);
    },
    //根据id查找业务流程信息
    findByIdWork(row) {
      findByIdWorkflow(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.ywTable = data;
        }
      });
    },
    //审核驳回
    noAuidt() {
      let map = {
        id: this.questionForm.id,
        list: this.questionForm.list,
        workflowContent: this.questionForm.workflowContent,
        sout: 1
      };
      this.audit(map);
    },
    findAllClick(){
      this.pageIndex=1
      this.findAll()
    },
    //批量审核通过
    batchAuidt() {
      var currentSelect = this.$refs.multipleTable.selection;
      var id = [];
      for (var i = 0; i < currentSelect.length; i++) {
        id.push(currentSelect[i].id);
      }
      let map = {
        id: id,
        list: this.questionForm1.list,
        workflowContent: this.questionForm1.workflowContent,
        sout: 0
      };
      this.audit(map);
    },
    //批量审核驳回
    batchNoAuidt() {
      var currentSelect = this.$refs.multipleTable.selection;
      var id = [];
      for (var i = 0; i < currentSelect.length; i++) {
        id.push(currentSelect[i].id);
      }
      let map = {
        id: id,
        list: this.questionForm1.list,
        workflowContent: this.questionForm1.workflowContent,
        sout: 1
      };
      this.audit(map);
    },
    //审核
    audit(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      row.userId = userinfo.userId
      auditMaintenance(row).then(datas => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message.warning(message)
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.dialogFormVisible1 = false;
          this.findAll();
          this.$message.success("审核完成")
        } else {
          this.$message.error("请求错误")

        }
      });
    },
    //维保审核弹框
    handleCreate() {
      let currentSelect = this.$refs.multipleTable.selection;
      if (currentSelect.length > 1) {
        this.tableData = currentSelect;
        if (currentSelect[0].yjfl == 'P0001') {
          this.options = this.wxry.bgwb
        }
        if (currentSelect[0].yjfl == "P0002") {
          this.options = this.wxry.jcwb
        }
        this.dialogFormVisible1 = true;
        var arr = []
        for (var i = 0; i < currentSelect.length; i++) {
          var iteam = currentSelect[i]
          var a = []
          if (iteam.person != null) {
            a = iteam.person.split(",")
            for (var i1 = 0; i1 < a.length; i1++) {
              if (arr.indexOf(a[i1]) == -1) {
                arr.push(a[i1])
              }
            }
          }
        }
        this.questionForm1.list = arr;

      } else if (currentSelect.length == 1) {
        this.questionForm = currentSelect[0];
        if (this.questionForm.yjfl == 'P0001') {
          this.options = this.wxry.bgwb
        }
        if (this.questionForm.yjfl == "P0002") {
          this.options = this.wxry.jcwb
        }
        var a = []
        if (this.questionForm.person != null) {
          a = this.questionForm.person.split(",")
        }
        this.questionForm.list = a
        this.findByIdWork(this.questionForm.id)
        this.dialogFormVisible = true;
      } else {
        this.$message.error("请选择设备"); // .....失败信息
      }
    },
    //查找所有维保信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"))

      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        content: this.deviceInfo.content,
        state: "1",
        userId: userinfo.userId
      };
      approveByIdMaintenance(map).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) { this.data = [] } else { this.data = data; }
          this.maintenanceData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    findRoleUser() {
      findByRoleUser().then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.wxry = data;
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.maintenanceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.maintenanceData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    findLable() {
      findByModule("维保管理").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.findRoleUser();
    var userinfo = JSON.parse(localStorage.getItem("user"))
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "104") {
        this.show.sh = true;
      }
    })
  }
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/maintenance/Audit.vue